module.exports = __webpack_public_path__ + "img/project-pic.f64253e8.jpg";